function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_407_21)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "path-1-outside-1_407_21",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0.126083,
  width: 51,
  height: 61,
  fill: "black"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  y: 0.126083,
  width: 51,
  height: 61
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.5924 12.5924L38.1261 3.12608H3V57.6279H47.5924V12.5924Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.5924 12.5924L38.1261 3.12608H3V57.6279H47.5924V12.5924Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.5924 12.5924H50.5924V11.3498L49.7137 10.4711L47.5924 12.5924ZM38.1261 3.12608L40.2474 1.00476L39.3687 0.126083H38.1261V3.12608ZM3 3.12608V0.126083H0V3.12608H3ZM3 57.6279H0V60.6279H3V57.6279ZM47.5924 57.6279V60.6279H50.5924V57.6279H47.5924ZM49.7137 10.4711L40.2474 1.00476L36.0048 5.2474L45.4711 14.7137L49.7137 10.4711ZM3 6.12608H38.1261V0.126083H3V6.12608ZM6 57.6279V3.12608H0V57.6279H6ZM47.5924 54.6279H3V60.6279H47.5924V54.6279ZM44.5924 12.5924V57.6279H50.5924V12.5924H44.5924Z",
  fill: "black",
  mask: "url(#path-1-outside-1_407_21)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38 13V3L48 13H38Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95473 20.4676H42.6377",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95473 30.377H42.6377",
  stroke: "black",
  strokeWidth: 3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95473 50.1958H42.6377",
  stroke: "black",
  strokeWidth: 3
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95473 40.2864H42.6377",
  stroke: "black",
  strokeWidth: 3
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_407_21",
  x: 0,
  y: 0.126083,
  width: 53.5924,
  height: 62.5018,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_407_21"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_407_21",
  result: "shape"
})));

function SvgDoc64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 63,
    viewBox: "0 0 54 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc64);
export default __webpack_public_path__ + "static/media/doc_64.406a1366.svg";
export { ForwardRef as ReactComponent };